import {Theme, ThemedText, ThemedView} from "@app/theme";
import SystemErrorIcon from "../../../../assets/Icons/SystemErrorIcon";
import Button from "@sharedComponents/Button/Button";
import React, {useEffect, useState} from "react";
import ScreenWrapper from "@hoc/ScreenWrapper";
import {NativeStackScreenProps} from "@react-navigation/native-stack";
import {PrivateStackParamList} from "@routes/types";
import {useTheme} from "@shopify/restyle";
import {getStepper} from "@screens/VerifyBankAccount/services/verifyBankService";
import {useAppSelector} from "@store/hooks";
import CommonHeader from "@sharedComponents/Header/Header";
import Stepper from "@sharedComponents/Stepper/Stepper";


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_PHOTO_MISMATCHH'>;


const KYCPhotoMismatch: React.FC<ScreenProps> = ({navigation, route}) => {
    const [stepperData, setStepperData] = useState<any>([]);
    const {userDetails} = useAppSelector(state => state.auth)
    const {colors} = useTheme<Theme>();

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await getStepper({applicationId: userDetails?.linkedApplications[0]?.applicationId});
                setStepperData(response);
            } catch (error) {
                console.log(error);
            } finally {
            }
        };
        fetchInitialData();
    }, []);

    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute: true}}>
            <CommonHeader
                label='Photo verification'
                navigation={navigation}
                pageName={route.name}
                hideBottomBorder={true}
            />
            <Stepper stepperData={stepperData}/>

            <ThemedView flex={1} backgroundColor={"bg-surface-primary"} >
                <ThemedView alignItems={"center"} justifyContent={"center"} alignSelf={"center"} flex={1} padding={"lg"}>
                    <SystemErrorIcon size={64} color={"#DE4043"}/>
                    <ThemedText textAlign={"center"} variant={"h5s"} color={"text-primary"} mt={"lg"}>The captured photo
                        does not match the Aadhar photo</ThemedText>
                    <ThemedView backgroundColor={"bg-fill-warning"} padding={"md"} mt={"lg"}>
                        <ThemedText textAlign={"center"} variant={"b3r"} color={"text-primary"}>
                            Please make sure that you capture the photo in a well-lit area and avoid wearing glasses or a cap.</ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView justifyContent={"flex-end"}>
                    <ThemedView justifyContent={"flex-end"} borderTopWidth={1} borderColor={"border-primary"}/>
                    <ThemedView padding={"lg"}>
                        <ThemedText variant={"b3r"} color={"text-secondary"} textAlign={"center"} mb={"sm"}>
                            Is the photo on your Aadhaar unclear?
                        </ThemedText>
                        <Button
                            label="Try another way to verify"
                            type="SOLID"
                            size='MD'
                            disabled={false}
                            handlePress={() => {
                                navigation.navigate("SUPPORTING_DOCUMENT")
                            }}
                            bg={colors['bg-action-primary']}
                            textColor={colors['text-primary']}
                        />
                        <ThemedView mt={"md"}>
                            <Button
                                label="Capture photo again"
                                type="OUTLINED"
                                size='MD'
                                disabled={false}
                                handlePress={() => {
                                    navigation.navigate("KYC_PHOTO_VERIFICATION", {
                                        capturePhotoOnDeviation: true,
                                        userPhoto: route?.params?.userPhoto
                                    })
                                }}
                                bg={colors['bg-action-primary']}
                                textColor={colors['text-primary']}
                            />
                        </ThemedView>
                    </ThemedView>
                    </ThemedView>
            </ThemedView>
        </ScreenWrapper>
    );
};
export default KYCPhotoMismatch;